import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AddressFragment, OrderAddress } from '../../../common/generated-types';
import { isValid } from 'date-fns';

@Component({
  selector: 'vdr-formatted-address',
  templateUrl: './formatted-address.component.html',
  styleUrls: ['./formatted-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormattedAddressComponent {
  @Input() address: AddressFragment | OrderAddress;

  getCountryName(): string {
    if (this.isAddressFragment(this.address)) {
      return this.address.country.name;
    } else {
      return this.address.country || '';
    }
  }

  getCustomFields(): Array<{ key: string; value: any }> {
    const customFields = (this.address as any).customFields;
    if (customFields) {
      return Object.entries(customFields)
        .filter(([key]) => key !== '__typename')
        .filter(([key, value]) => value)
        .map(([key, value]) => ({ key, value: (value as any)?.toString() ?? '-' }));
    } else {
      return [];
    }
  }

  getHref(customField) {
    const customFields = (this.address as any).customFields;
    if (customField.key === 'latitude') {
      return `https://www.google.com/maps/search/?api=1&query=${customField.value},${customFields.longitude}`;
    }
    if (customField.key === 'longitude') {
      return `https://www.google.com/maps/search/?api=1&query=${customFields.latitude},${customField.value}`;
    }
    if (customField.key === 'googleAddress') {
      const searchAddress = customField.value.split(' ').join('+');
      return `https://www.google.com/maps/search/?api=1&query=${searchAddress}`;
    }
  }

  clickable(customField) {
    if (customField.key === 'latitude' || customField.key === 'longitude' || customField.key === 'googleAddress') {
      return true;
    }
    return false;
  }

  isDate(value: any) {
    return isValid(new Date(value));
  }

  private isAddressFragment(input: AddressFragment | OrderAddress): input is AddressFragment {
    return typeof input.country !== 'string';
  }
}
